import { useI18n } from '../../../i18n';
// ============================================
// EmployeeSearchBar Component
// Search input + job title filter + status filter
// ============================================

import { SearchInput } from '../../../components/shared/SearchInput';
import { SelectDropdown } from '../../../components/shared/SelectDropdown';
import { cn } from '../../../utils/cn';

// ============================================
// Types
// ============================================

interface EmployeeSearchBarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  selectedJobTitle: string;
  onJobTitleChange: (value: string) => void;
  selectedStatus: string;
  onStatusChange: (value: string) => void;
  jobTitleOptions: { value: string; label: string }[];
  className?: string;
}

// ============================================
// Constants
// ============================================

const STATUS_OPTIONS = [
  { value: '', label: 'All Status' },
  { value: 'active', label: 'Active' },
  { value: 'on_leave', label: 'On Leave' },
];

// ============================================
// Component
// ============================================

export function EmployeeSearchBar({
  searchValue,
  onSearchChange,
  selectedJobTitle,
  onJobTitleChange,
  selectedStatus,
  onStatusChange,
  jobTitleOptions,
  className,
}: EmployeeSearchBarProps) {
  const { t } = useI18n();
  return (
    <div
      className={cn(
        'flex flex-col gap-4 rounded-xl bg-white p-4 shadow-sm sm:flex-row sm:items-center',
        className
      )}
      style={{ boxShadow: '0px 1px 2px rgba(0,0,0,0.05)' }}
    >
      {/* Search Input */}
      <div className="flex-1">
        {/* Bug #69: placeholder cũ hứa tìm được theo "code", nhưng nhân viên
            không có mã nào ở BE (xem ghi chú ở EmployeesPage) — lời hứa đó là
            nguồn của chính báo cáo lỗi. Nói đúng thứ tìm được cho tới khi BE bổ
            sung `employee_code`. */}
        <SearchInput
          value={searchValue}
          onChange={onSearchChange}
          placeholder={t('searchByNameOrPhone')}
        />
      </div>

      {/* Filters */}
      <div className="grid grid-cols-2 gap-3 sm:flex sm:items-center sm:gap-4">
        {/* Job Title Filter */}
        <SelectDropdown
          value={selectedJobTitle}
          onChange={onJobTitleChange}
          options={jobTitleOptions}
          className="w-full sm:w-auto sm:min-w-[160px]"
        />

        {/* Status Filter */}
        <SelectDropdown
          value={selectedStatus}
          onChange={onStatusChange}
          options={[
            { value: '', label: t('allStatusOption') },
            { value: 'active', label: t('active') },
            { value: 'on_leave', label: t('onLeave') }
          ]}
          className="w-full sm:w-auto sm:min-w-[140px]"
        />
      </div>
    </div>
  );
}
